
import { useState } from 'react';

const FeaturedProjects = () => {
  const votingProjects = [
    {
      title: "MindfulTech App",
      description: "Mental health support through AI-powered mindfulness",
      votes: "1,234",
      timeLeft: "12 days",
      category: "Health",
      image: "https://public.readdy.ai/ai/img_res/ad9ea29fc1d11990a2cd3e07ac796e89.jpg"
    },
    {
      title: "Ocean Cleanup Initiative",
      description: "Innovative technology to remove plastic from oceans",
      votes: "2,156",
      timeLeft: "8 days", 
      category: "Environment",
      image: "https://readdy.ai/api/search-image?query=ocean%20cleanup%20technology%20equipment%20on%20clean%20blue%20water%2C%20modern%20environmental%20technology%2C%20professional%20photography%2C%20blue%20and%20white%20tones&width=400&height=300&seq=5&orientation=landscape"
    },
    {
      title: "CodeCamp for Kids",
      description: "Teaching programming skills to children in rural areas",
      votes: "987",
      timeLeft: "15 days",
      category: "Education", 
      image: "https://readdy.ai/api/search-image?query=children%20learning%20programming%20on%20computers%20in%20modern%20classroom%2C%20bright%20educational%20environment%2C%20clean%20professional%20photography%2C%20colorful%20but%20organized&width=400&height=300&seq=6&orientation=landscape"
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-black via-blue-950 to-blue-900">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mb-8">
              <i className="ri-star-line text-2xl text-white"></i>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Currently Voting
            </h2>
            <p className="text-xl text-white/80 font-light max-w-2xl mx-auto">
              Vote for the projects you believe in and help dreams become reality
            </p>
            <div className="w-24 h-1 bg-white mx-auto mt-8"></div>
          </div>

          {/* Projects Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {votingProjects.map((project, index) => (
              <div key={index} className="bg-white/5 rounded-2xl overflow-hidden border border-white/10 hover:border-white/20 transition-all duration-300 group">
                <div className="relative overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-white/20 backdrop-blur-sm text-white px-3 py-1 rounded-full text-sm font-medium">
                      {project.category}
                    </span>
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-bold text-white mb-3">
                    {project.title}
                  </h3>
                  <p className="text-white/80 font-light mb-6 leading-relaxed">
                    {project.description}
                  </p>
                  
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="text-sm text-white/60 mb-1">Votes</div>
                      <div className="text-lg font-bold text-white">{project.votes}</div>
                    </div>
                    <div className="text-right">
                      <div className="text-sm text-white/60 mb-1">Time Left</div>
                      <div className="text-lg font-bold text-white">{project.timeLeft}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;
